import { Box, Button } from '@mui/material'
import React, { useState } from 'react'

const AlphaSortBar = ({ lettersArray, activeLetter, setActiveLetter, directionLeftBar=false}) => {
  
  
  const [isHideLetterBar, setIsHideLetterBar] = useState(false)
  const [directionBar, setDirectionBar] = useState(directionLeftBar)
  // console.log(directionLeftBar);
  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      width: '30px',
      height: 'fit-content',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      top: '60px',
      right: directionBar ? 'auto' : '10px',
      left: directionBar ? '10px' : 'auto',
      background: '#ffffffe0',
      borderRadius: '6px',
      // filter: 'drop-shadow(0px, 0px, 3px #00000057)',
    }}>
      {!isHideLetterBar && <>
      <Button
        sx={{
          padding: 0,
          minWidth: '30px',
          height: '25px',
          backgroundColor: activeLetter === null ? '#176318' : '#fff',
          color: activeLetter === null ? '#fff' : '#176318',
        }}
        onClick={() => {setActiveLetter(null)}}
      >
        All
      </Button>
      {lettersArray.map((el, index) => <Button
        key={index}
        sx={{
          padding: 0,
          minWidth: '30px',
          height: '25px',
          backgroundColor: activeLetter === el ? '#176318' : '#fff',
          color: activeLetter === el ? '#fff' : '#176318',
        }}
        onClick={() => {setActiveLetter(el)}}
      >
        {el}
      </Button>)}</>}
      <Button
        sx={{
          padding: 0,
          minWidth: '30px',
          height: '25px',
          backgroundColor: isHideLetterBar ? '#176318' : '#fff',
          color: isHideLetterBar ? '#fff' : '#176318',
        }}
        onClick={() => {setIsHideLetterBar(!isHideLetterBar)}}
      >
        {isHideLetterBar ? '<' : '>'}
      </Button>
    </Box>
  )
}

export default AlphaSortBar